import React, { useEffect, useState } from "react";
import { Tabs, Card, Input, Button, List, Space, Table, Popover } from "antd";
import { useNavigate } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import { fetchBulkEmailListData, saveBulkEmail } from "../../../features/members/membersSlice";
import { useDispatch, useSelector } from "react-redux";
import { appDispatch, RootState } from "../../../app/store";
import { toast } from 'react-toastify';
import { ColumnsType } from "antd/es/table";

const { TextArea } = Input;

interface BulkEmail {
  id: number;
  subject: string;
  status: string;
  total_recipients: number;
  created_at: string;
}

const BulkEmailPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<appDispatch>();


  const stripHtml = (html: string = ""): string =>
  html.replace(/<[^>]*>?/gm, "");

const getWordCount = (text: string): number =>
  text.trim().split(/\s+/).length;

const truncateWords = (text: string, limit: number): string => {
  const words = text.trim().split(/\s+/);
  return words.length > limit
    ? words.slice(0, limit).join(" ") + "..."
    : text;
};

    const fetchBulkEmailList = useSelector(
      (state: RootState) => state.members.fetchBulkEmailList.fetchBulkEmailListData?.records) || [];
    const [activeTab, setActiveTab] = useState("1");

    const [emails, setEmails] = useState([
{}
    ]);
    console.log("child page rendered")
console.log(fetchBulkEmailList,"JJJ")
  useEffect(() => {
  if (activeTab === "2") {
    const thunkArgs: any = {};
    dispatch(fetchBulkEmailListData(thunkArgs));
  }
}, [activeTab]);

 const columns: ColumnsType<BulkEmail> = [
  {
    title: "Subject",
    dataIndex: "subject",
    key: "subject",
    render: (text) => (
      <span style={{ color: "#fff" }}>{text}</span>
    ),
  },

   {
  title: "Content",
  dataIndex: "content",
  key: "content",
  render: (text: string) => {
    const cleanText = stripHtml(text);
    const wordCount = getWordCount(cleanText);
    const previewText = truncateWords(cleanText, 20);

    return wordCount > 20 ? (
      <Popover
        content={
          <div style={{ maxWidth: 400, whiteSpace: "pre-wrap" }}>
            {cleanText}
          </div>
        }
        title="Email Content"
        trigger="hover"
      >
        <span
          style={{
            color: "#e9eafe",
            cursor: "pointer",
          }}
        >
          {previewText}
        </span>
      </Popover>
    ) : (
      <span style={{ color: "#fff" }}>{cleanText}</span>
    );
  },
},
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (text) => (
      <span style={{ color: "#1a865f", textTransform: "capitalize" }}>
        {text}
      </span>
    ),
  },
  {
    title: "Recipients",
    dataIndex: "total_recipients",
    key: "total_recipients",
    align: "center", // ✅ now correctly typed
    render: (count) => (
      <span style={{ color: "#c7cace" }}>{count}</span>
    ),
  },
  {
    title: "Sent On",
    dataIndex: "created_at",
    key: "created_at",
    width: 200,
    render: (date) => (
      <span style={{ color: "#95989d" }}>
        {new Date(date).toLocaleString()}
      </span>
    ),
  },
];

    const [subject, setSubject] = useState("");
    const [content, setContent] = useState("");

    const handleSendEmail = () => {
     
        // Clicking Send with either field blank used to return silently: no
        // message, no highlight, the button simply appeared dead.
        if (!subject.trim() || !content.trim()) {
            toast.error("Enter both a subject and a message before sending.");
            return;
        }

        const payload = {
            subject: subject,
            content: content
        }
        dispatch(saveBulkEmail(payload))
            .unwrap()
            .then(async (res) => {
                toast.success("Bulk email sent successfully");
                // The row is added only once the send actually succeeded. It
                // used to be prepended before dispatching, so a failed send
                // still showed the email in the list as though it had gone out.
                setEmails((prev: any) => [
                    {
                        id: Date.now(),
                        subject,
                        content,
                        date: new Date().toISOString().split("T")[0],
                    },
                    ...prev,
                ]);
                setSubject("");
                setContent("");
            })
            .catch((err: any) => {
                // This was console.error only, so a failed bulk send told the
                // admin nothing at all.
                toast.error(
                    typeof err === 'string' ? err : (err?.message || "Could not send the bulk email.")
                );
            });


    };

    return (
        <div
            style={{
                background: "#11161c",
                minHeight: "100vh",
                width: "100vw",
                margin: 0,
                padding: 24,
                boxSizing: "border-box",
            }}
        >
            <Card
                style={{
                    background: "#21262c",
                    border: "1px solid #21262c",
                    color: "#fff",
                    width: "100%",
                }}
                title={
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "auto 1fr auto",
                            alignItems: "center",
                        }}
                    >
                        {/* Back button */}
                        <Button
                            type="text"
                            icon={<LeftOutlined />}
                            onClick={() => navigate(-1)}
                            style={{ color: "#6e7afb" }}
                        />

                        {/* Center title */}
                        <span
                            style={{
                                color: "#fff",
                                fontSize: 16,
                                fontWeight: 500,
                                textAlign: "center",
                            }}
                        >
                            Bulk Email
                        </span>

                        {/* Right spacer for perfect centering */}
                        <div />
                    </div>
                }
            >
                <Tabs
                   activeKey={activeTab}
  onChange={(key) => setActiveTab(key)}
                    items={[
                        {
                            key: "1",
                            label: "Compose & Send",
                            children: (
                                <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                    <Input
                                        placeholder="Email Subject"
                                        value={subject}
                                        onChange={(e) => setSubject(e.target.value)}
                                    />
                                    <TextArea
                                        rows={6}
                                        placeholder="Email Content"
                                        value={content}
                                        onChange={(e) => setContent(e.target.value)}
                                    />
                                    <Button type="primary" onClick={handleSendEmail}>
                                        Send Bulk Email
                                    </Button>
                                </Space>
                            ),
                        },
                        {
                            key: "2",
                            label: "Email History",
                            children: (
                                <Table
                                    columns={columns}
                                    dataSource={fetchBulkEmailList}
                                    rowKey="id"
                                    pagination={{ pageSize: 5 }}
                                    style={{ background: "#21262c" }}
                                />
                            ),
                        }
                    ]}
                />
            </Card>
        </div>
    );
};

export default BulkEmailPage;
